import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FlowCard from './FlowCard';

/**
 * Shown on `completed` (until the current user has reviewed). 1–5 star rating +
 * optional comment. Submits via the parent's onSubmit(rating, comment).
 */
export default function ReviewCard({ onSubmit, busy, roleColorVar }) {
  const { t } = useTranslation('common');
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');

  return (
    <FlowCard step={t('flow.step_review')} title={t('flow.review_title')} roleColorVar={roleColorVar}>
      <p>{t('flow.review_body')}</p>
      <div className="flow-stars" role="radiogroup" aria-label={t('flow.review_title')}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            type="button"
            className={`flow-star ${n <= rating ? 'filled' : ''}`}
            aria-label={String(n)}
            aria-pressed={n === rating}
            data-star={n}
            onClick={() => setRating(n)}
          >
            ★
          </button>
        ))}
      </div>
      <textarea
        className="flow-review-comment"
        rows={3}
        placeholder={t('flow.review_placeholder')}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      />
      <div className="flow-card-actions">
        <button
          type="button"
          className="flow-btn flow-btn--primary"
          disabled={!rating || busy}
          data-action="submit_review"
          onClick={() => onSubmit(rating, comment.trim() || null)}
        >
          {t('flow.review_submit')}
        </button>
      </div>
    </FlowCard>
  );
}
